import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "contact-us-social";

const GET_CONTACT_US_SOCIAL_URL = `${prefix}/all`;
const CREATE_CONTACT_US_SOCIAL_URL = `${prefix}/create`;
const UPDATE_CONTACT_US_SOCIAL_URL = `${prefix}/update-by-id`;
const DELETE_CONTACT_US_SOCIAL_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllContactUsSocial
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getAllContactUsSocial = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_CONTACT_US_SOCIAL_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllContactUsSocial");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllContactUsSocial */

/**
 * @func createContactUsSocial
 * @desc user register
 * @author jew
 * @param {Object} body - create user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */

export const createContactUsSocial = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_CONTACT_US_SOCIAL_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createContactUsSocial");
        if (err) throw err;
        return undefined;
    }
};

/** End @func createContactUsSocial */

/**
/**
 * @func updateContactUsSocial
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */

export const updateContactUsSocial = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_CONTACT_US_SOCIAL_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateContactUsSocial");
        if (err) throw err;
        return undefined;
    }
};

/** End @func updateContactUsSocial */

/**
/**
 * @func deleteContactUsSocial
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */

export const deleteContactUsSocial = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_CONTACT_US_SOCIAL_URL}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteContactUsSocial");
        if (err) throw err;
        return undefined;
    }
};

/** End @func deleteContactUsSocial */
